// NOTE: this is to allow all environment variables to be available at runtime
// in code, since razzle by default only allows razzle defined environment
// variables to be set at build time. The initial object below allows build time
// variables to also be exposed through the single runtimeEnv object to avoid
// having to check multiple env objects
export const runtimeEnv: Readonly<{ [key: string]: string | undefined }> = Object.keys(
  process.env
).reduce(
  (env, key) => {
    env[key] = process.env[key];
    return env;
  },
  {
    // configure any build time razzle environment variables that you
    // would like exposed in code as well
    NODE_ENV: process.env.NODE_ENV,
    HOST: process.env.HOST,
    PORT: process.env.PORT,
    PUBLIC_PATH: process.env.PUBLIC_PATH,
    BUILD_BUILDNUMBER: process.env.RAZZLE_BUILD_BUILDNUMBER,
    DEPLOYMENT_ENV: process.env.DEPLOYMENT_ENV,
    RAZZLE_PUBLIC_DIR: process.env.RAZZLE_PUBLIC_DIR,
    RAZZLE_ENABLE_HTTPS: process.env.RAZZLE_ENABLE_HTTPS,
    RAZZLE_CERT_DIRECTORY: process.env.RAZZLE_CERT_DIRECTORY,
    RAZZLE_SSL_CERT_PFX: process.env.RAZZLE_SSL_CERT_PFX,
    RAZZLE_SSL_CERT_PASSWORD_FILE: process.env.RAZZLE_SSL_CERT_PASSWORD_FILE,
    RAZZLE_AAD_REDIRECT_URL: process.env.RAZZLE_AAD_REDIRECT_URL,
  }
);
